export const platformColors = {
  multiPlatform: '#199DA3',
  news: '#199DA3',
  newspaper: '#199DA3',
  kiosk: '#0F7173',
  instagram: '#C63C73',
  instagramComments: '#9CAEBB',
  twitter: '#5AD1F6',
  virasty: '#3b96d2',
  telegram: '#32AADD',
  linkedin: '#0a66c2',
  telegramGroups: '#32AADD',
  nativePlatforms: '#199DA3',
};
